<app-docent-schedule-hash
  [docentName]="selectedUser.fullName"
></app-docent-schedule-hash>

<div class="timetable-preview-header">
  <h3>Stundenplan von {{ selectedUser.fullName }}</h3>
  <app-meeting-link-docent-actions
    [meetingData]="{ docentName: selectedUser.fullName }"
    [lecturerUsers]="lecturerUsers"
    (meetingChanged)="reloadTimetable()"
  ></app-meeting-link-docent-actions>
</div>

<!-- Der Benutzerdialog zeigt nur an; eingetragen wird ausschließlich im Stundenplan des Dozenten. -->
<app-docent-timetable-table
  [entries]="(timetable$ | async) ?? []"
  [rows]="10"
  [showClassbook]="false"
  emptyMessage="Keine Unterrichtstermine in den nächsten 30 Tagen."
></app-docent-timetable-table>
